const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       roleId: payload.role,
  //       status: payload.status,
  //       sortBy
  //     };

  //     let url = `/api/user/cerdas`;
  //     if ((payload.status !== '' && typeof payload.status != 'undefined') || payload.role) {
  //       url = url.concat(`/filter`);
  //     }

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search, roleId, status }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/cerdas/filter?search=${search}&roleId=${roleId ?? ''}&status=${status ?? ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchGMT({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/school-admin/timezone-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchProfile({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/profile`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    if (!payload.image) formData.delete('image');
    return window.axios.post('/api/user/cerdas', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // eslint-disable-next-line no-unused-vars
  saveTimeZone({ rootGetters }, payload) {
    var schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.put(`api/user/school-admin/${schoolId}/timezone`, {
      ...payload
    });
  },
  // eslint-disable-next-line no-unused-vars
  saveLanguage({ rootGetters }, payload) {
    var schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.put(`api/user/school-admin/${schoolId}/language`, {
      ...payload
    });
  },

  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    if (!payload.image) formData.delete('image');
    return window.axios.put(`/api/user/cerdas/${payload.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // eslint-disable-next-line no-unused-vars
  saveToken({ rootGetters }, payload) {
    const { userId } = payload;
    return window.axios.put(`api/user/${userId}/token`, {
      token: payload.token
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateprofile({ commit }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    if (!payload.image) formData.delete('image');

    const role = ['cerdas', 'school-admin', 'parent', 'teacher', 'student', 'school-advisor'];
    const endPoint = role?.[payload.roleId - 1];
    if (endPoint) {
      return window.axios.put(`/api/profile/${endPoint}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
  },

  // eslint-disable-next-line no-unused-vars
  updatePassword({ commit }, payload) {
    return window.axios.post(`/api/profile`, payload);
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/user/${payload.userId}`);
  },

  // eslint-disable-next-line no-unused-vars
  generatePassword({ commit }, payload) {
    return window.axios.put(`/api/user/generate/${payload.userId}`);
  },

  // eslint-disable-next-line no-unused-vars
  generatePasswordParentSolo({ commit }, payload) {
    return window.axios.put(`/api/user/generate/${payload.userParentId}`);
  },

  // eslint-disable-next-line no-unused-vars
  generatePasswordParent({ commit }, payload) {
    return window.axios.put(`/api/user/student/${payload.userId}/parent/${payload.userParentId}`);
  },

  // eslint-disable-next-line no-unused-vars
  download({ commit }, payload) {
    return window.axios.get('/api/user/cerdas/download');
  },

  // eslint-disable-next-line no-unused-vars
  deactivate({ commit }, userId) {
    try {
      console.log('window.axios.put : ', window.axios.put);
      return window.axios.put(`/api/user/deactivate/${userId}`);
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
